import * as React from "react";
import {Button, Icon, Label} from "semantic-ui-react";
import {backend} from "../../../../../../xconvert-backend";
import {authentication} from "../../../../../../authentication";
import {Queue, QueuedEvent, QueueWithEvent} from "../../../../../../generated/index";
import {QueuedEventsTable} from "../../events/QueuedEventsTable";

export interface TestSuppressionScriptModalMultiProps {
    queue: Queue
    history: any
    updateResponse: (xRequestId: string, output: string) => void
}

export function TestSuppressionScriptModalMulti(props: TestSuppressionScriptModalMultiProps) {
    const [selected, setSelected] = React.useState<QueuedEvent[]>([])

    async function test() {
        let auth = backend.withTokenAuthHeader(authentication.token)
        let request = {} as QueueWithEvent
        request.queue = props.queue
        request.events = selected

        let response = await fetch('/api/queues/testSuppressionScriptTest', {
            method: 'POST',
            headers: {
                "Authorization": auth.headers.Authorization.toString(),
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(request)
        })

        props.updateResponse(
            response.headers.get("x-request-id"),
            (await response.json()).events
        )
    }

    return <>
        <div
            style={{
                marginBottom: 5,
            }}
        >
            <Label>Input QueuedEvent</Label>
            <Button
                primary
                icon
                labelPosition="left"
                style={{float: "right"}}
                disabled={selected.length === 0}
                onClick={() => test()}
            >
                <Icon name="play" />
                Test
            </Button>

        </div>

        <QueuedEventsTable
            onClickedEvent={() => {
            }}
            onSelectionChanged={(newSelected) => setSelected(newSelected)}
            history={props.history}
        />
    </>
}
